import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { parsePhoneNumber, formatPhoneNumber } from 'utilities/strings'
import { BaseInput } from '../base-input'
import { Label } from '../label'
import { HelperText } from '../helper-text'
import { FormControlProps } from '../types'
import s from './styles.module.css'

export const PhoneInput = React.forwardRef<HTMLInputElement, FormControlProps>(
  function PhoneInput(props, ref) {
    const {
      className,
      disabled,
      error,
      errorText,
      focus,
      helperText,
      hover,
      fullWidth = false,
      iconLeft,
      iconRight,
      inputProps,
      inputClassName,
      label,
      labelClassName,
      labelProps,
      helperTextClassName,
      helperTextProps,
      name,
      onBlur,
      onChange,
      onFocus,
      preventScrollOnFocus,
      value,
      ...rest
    } = props

    const [formattedValue, setFormattedValue] = useState<string>(
      !!value ? formatPhoneNumber(value) : ''
    )

    useEffect(() => {
      if (typeof value !== 'undefined') {
        const parsed = parsePhoneNumber(value)
        const formatted = formatPhoneNumber(parsed)
        setFormattedValue(formatted)
      }
    }, [value])

    return (
      <div className={className} {...rest}>
        <Label className={labelClassName} disabled={disabled} {...labelProps}>
          <span className={s.labelText}>{label}</span>
          <BaseInput
            className={inputClassName}
            disabled={disabled}
            error={error}
            hover={hover}
            focus={focus}
            fullWidth={fullWidth}
            iconLeft={iconLeft}
            iconRight={iconRight}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            preventScrollOnFocus={preventScrollOnFocus}
            ref={ref}
            type="tel"
            value={formattedValue}
            {...inputProps}
          />
        </Label>
        <HelperText
          className={cn(s.helperText, helperTextClassName)}
          error={error}
          errorText={errorText}
          text={helperText}
          {...helperTextProps}
        />
      </div>
    )
  }
)
